import {
  CM_PRIMARY_ID,
  ELECTION_TYPE,
  SE_COMMITTEE_ID,
} from '../../../utils/constants';

export const NA_VALUE = -1;

export const groupNominationsByCommittee = (
  rankedNominations,
  sectionalCommitteesWithCmse,
  candidateArray,
) => {
  const grouped = {};

  rankedNominations.forEach((nomination) => {
    const attrs = nomination.attributes || nomination;
    const { electionTypeId, sectionalCommitteeId, candidateId } = attrs;
    const ranking = parseInt(nomination.ranking);

    let committeeId;
    let committeeName;

    if (electionTypeId === ELECTION_TYPE.CORRESPONDING_MEMBER) {
      committeeId = CM_PRIMARY_ID;
      committeeName = 'Corresponding Membership';
    } else if (electionTypeId === ELECTION_TYPE.SPECIAL_ELECTION) {
      committeeId = SE_COMMITTEE_ID;
      committeeName = 'Special Election';
    } else {
      committeeId = sectionalCommitteeId;
      committeeName =
        sectionalCommitteesWithCmse[sectionalCommitteeId] || 'Unknown';
    }

    if (!grouped[committeeId]) {
      grouped[committeeId] = {
        committeeId,
        committeeName,
        nominations: [],
      };
    }

    const candidate = candidateArray.find((c) => c.id === candidateId);

    if (candidate) {
      const candidateAttrs = candidate.attributes || candidate;
      grouped[committeeId].nominations.push({
        nominationId: nomination.id,
        nominationStateId: nomination.nominationStateId,
        rank: ranking,
        candidateName: `${candidateAttrs.name} ${candidateAttrs.lastName}`,
        candidateId,
      });
    }
  });

  Object.values(grouped).forEach((committee) => {
    committee.nominations.sort((a, b) => a.rank - b.rank);
  });

  return Object.values(grouped).sort((a, b) => a.committeeId - b.committeeId);
};

export const checkAllocationWarnings = (
  nominationId,
  selectedCouncilMemberId,
  committeeId,
  allocations,
  groupedData,
) => {
  if (!selectedCouncilMemberId || selectedCouncilMemberId === NA_VALUE) {
    return null;
  }

  const warnings = [];

  groupedData.forEach((committee) => {
    committee.nominations.forEach((nomination) => {
      if (nomination.nominationId === nominationId) return;

      const allocation = allocations[nomination.nominationId];
      if (allocation?.value === selectedCouncilMemberId) {
        if (committee.committeeId === committeeId) {
          warnings.push({
            type: 'same-committee',
            committeeName: committee.committeeName,
            candidateName: nomination.candidateName,
          });
        } else {
          warnings.push({
            type: 'different-committee',
            committeeName: committee.committeeName,
            candidateName: nomination.candidateName,
          });
        }
      }
    });
  });

  return warnings.length > 0 ? warnings : null;
};
